import { CalendarOutlined } from '@ant-design/icons';

const meses = {
  id: 'group-meses',
  title: 'Gestão',
  type: 'group',
  children: [
    {
      id: 'meses',
      title: 'Meses',
      type: 'item',
      url: '/meses',
      icon: CalendarOutlined,
      breadcrumbs: false,
    },
  ],
};

export default meses;
